var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDocumentSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.91797 2.125V4.95833C9.91797 5.34953 10.2351 5.66667 10.6263 5.66667H13.4596",
    stroke: "#0084B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.043 14.875H4.95964C4.17723 14.875 3.54297 14.2407 3.54297 13.4583V3.54167C3.54297 2.75926 4.17723 2.125 4.95964 2.125H9.91797L13.4596 5.66667V13.4583C13.4596 14.2407 12.8254 14.875 12.043 14.875Z",
    stroke: "#0084B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocumentSvg);
export default __webpack_public_path__ + "static/media/fileDocumentSVG.2af451cbe2291dd65bbd6a319c2560af.svg";
export { ForwardRef as ReactComponent };